export type ColorSchemeType = 'color_scheme_type' | 'custom_color_type';

export interface TracklistAppBlockProps {
  albumId?: string;
  productId?: string;
  mode?: 'live' | 'demo';
  colorSetting?: ColorSchemeType;
  buttonColor?: string;
  buttonTextColor?: string;
  secondaryButtonColor?: string;
  secondaryButtonTextColor?: string;
  // Tracklist-specific settings
  tlTextColor?: string;
  tlTrackSeparatorWidth?: string;
  tlTrackSeparatorColor?: string;
  tlShowTrackLength?: boolean;
  tlPaddingTop?: string;
  tlPaddingBottom?: string;
  // Audio player bar theming
  apTextColor?: string;
  apBackgroundColor?: string;
  apBorderColor?: string;
  apBorderWidth?: string;
  apBorderRadius?: string;
  apProgressBarColor?: string;
  apProgressBackgroundColor?: string;
  apShowTimeElapsed?: boolean;
  apShowArtwork?: boolean;
  apShowPlayer?: boolean;
  showCountdown?: boolean;
  countdownBackgroundColor?: string;
  countdownTextColor?: string;
}

const TRACKLIST_APP_BLOCK_ATTRIBUTE_MAP: Record<string, keyof TracklistAppBlockProps> = {
  'album-id': 'albumId',
  'product-id': 'productId',
  'mode': 'mode',
  'color-setting': 'colorSetting',
  'button-color': 'buttonColor',
  'button-text-color': 'buttonTextColor',
  'secondary-button-color': 'secondaryButtonColor',
  'secondary-button-text-color': 'secondaryButtonTextColor',
  'tl-text-color': 'tlTextColor',
  'tl-track-separator-width': 'tlTrackSeparatorWidth',
  'tl-track-separator-color': 'tlTrackSeparatorColor',
  'tl-show-track-length': 'tlShowTrackLength',
  'tl-padding-top': 'tlPaddingTop',
  'tl-padding-bottom': 'tlPaddingBottom',
  'ap-text-color': 'apTextColor',
  'ap-background-color': 'apBackgroundColor',
  'ap-border-color': 'apBorderColor',
  'ap-border-width': 'apBorderWidth',
  'ap-border-radius': 'apBorderRadius',
  'ap-progress-bar-color': 'apProgressBarColor',
  'ap-progress-background-color': 'apProgressBackgroundColor',
  'ap-show-time-elapsed': 'apShowTimeElapsed',
  'ap-show-artwork': 'apShowArtwork',
  'ap-show-player': 'apShowPlayer',
  'show-countdown': 'showCountdown',
  'countdown-background-color': 'countdownBackgroundColor',
  'countdown-text-color': 'countdownTextColor',
};

const BOOLEAN_PROPS = new Set<string>([
  'tlShowTrackLength',
  'apShowTimeElapsed',
  'apShowArtwork',
  'apShowPlayer',
  'showCountdown',
]);

function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    return value === 'true';
  }
  return value;
}

export const TRACKLIST_APP_BLOCK_OBSERVED_ATTRIBUTES = Object.keys(TRACKLIST_APP_BLOCK_ATTRIBUTE_MAP);

export function extractTracklistAppBlockAttributes(
  element: HTMLElement
): Partial<TracklistAppBlockProps> {
  const props: Partial<TracklistAppBlockProps> = {};

  for (const [attrName, propName] of Object.entries(TRACKLIST_APP_BLOCK_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }

  return props;
}
